import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './SchumerTable.css';
import { getSecChildren } from '../PageSection/PageSection';
import withAsyncImport from '../../withAsyncImport';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Row, Col, Container } from '../../importCL';

const CobGrid = withAsyncImport(() => import('../CobGrid/CobGrid'));

interface ITableRow {
    rowDescription?: string;
    hideBorder?: boolean;
    subText?: boolean;
}

interface ISchumerTableProps extends MappedComponentProperties {
    cqItems?: string[];
    cqItemsOrder?: string[];
    columnClasses?: string[];

    tableRows?: ITableRow[];
    tableHeader?: string;
    padding?: string;
}

export const SchumerTableEditConfig = {
    emptyLabel: 'SchumerTable',
    isEmpty: (props: PropsWithChildren<ISchumerTableProps>) => {
        return !props || !props.tableHeader;
    },
};

const SchumerTable = (props: PropsWithChildren<ISchumerTableProps>): JSX.Element => {
    return (
        <div id='schumer-table' className='SchumerTable'>
            <Container className={  `SchumerTable__container ${props.padding === 'top-pad' ? 'SchumerTable__container--topPadding':''}` +
                                    `${props.padding === 'bottom-pad' ? 'SchumerTable__container--bottomPadding':''}`} role='table'>
                <Row>
                    <Col className='SchumerTable__title' role='caption'>
                        {transformHTMLParserLinks(wrapTrademarkSuperscript(props.tableHeader))}
                    </Col>
                </Row>
                <div role='rowgroup'>
                {props.tableRows && props.tableRows.map((tableRows: ITableRow, rowIndex: number) => (
                        <Row key={rowIndex} className={`SchumerTable__row SchumerTable__row--border ${tableRows.hideBorder ? '' :'SchumerTable__row--borderBottom'}`} role='row'>
                            <Col xs={3} md={3} className='SchumerTable__leftColumn' role='rowheader' >
                                {tableRows.subText ?
                                    <Container>
                                        <ul className='SchumerTable__bullets'>
                                            <li>
                                                {transformHTMLParserLinks(wrapTrademarkSuperscript(tableRows.rowDescription))}
                                            </li>
                                        </ul>
                                    </Container> :
                                    <div className='SchumerTable__boldText'>
                                        {transformHTMLParserLinks(wrapTrademarkSuperscript(tableRows.rowDescription))}
                                    </div>
                                }
                            </Col>
                            <Col xs={3} md={9} className='SchumerTable__rightColumn' role='cell'>
                                {
                                    <div className='SchumerTable__rightColumnContainer'>
                                        {/* This is a single line for a reason, don't change it */}
                                        <CobGrid isInEditor={props.isInEditor} cqPath={`${props.cqPath}/itemCell_${rowIndex}`} cqItems={getSecChildren(props, `itemCell_${rowIndex}`)} cqItemsOrder={props.cqItems[`itemCell_${rowIndex}`][':itemsOrder']}/>
                                    </div>
                                }
                            </Col>
                        </Row>
                ))}
                </div>
            </Container>
        </div>);
};

export default SchumerTable;